import React from 'react'
import useCart from 'store/CartProvider'

const ChooseBank = () => {
  const { bank, chooseBank } = useCart()

  return (
    <div className="pay-method-div flex flex-wrap gap-2">
      <div className="w-full">
        <span>აირჩიე ბანკი:</span>
      </div>
      <div
        className={`flex pay-method-single ${bank === 'tbc' ? 'selected' : ''}`}
        onClick={() => chooseBank('tbc')}
      >
        <img className="w-24" alt="citrus tbc" src="/img/tbc-logo.png" />
      </div>

      <div
        className={`flex pay-method-single ${bank === 'bog' ? 'selected' : ''}`}
        onClick={() => chooseBank('bog')}
      >
        <img
          className="w-24"
          alt="citrus bank of georgia"
          src="/img/bog-logo.png"
        />
      </div>
      <div
        className={`flex pay-method-single ${
          bank === 'rebank' ? 'selected' : ''
        }`}
        onClick={() => chooseBank('rebank')}
      >
        <img className="w-24" alt="citrus rebank" src="/img/rebank-logo.svg" />
      </div>
      <div
        className={`flex pay-method-single ${
          bank === 'liberty' ? 'selected' : ''
        }`}
        onClick={() => chooseBank('liberty')}
      >
        <img
          className="w-24 object-contain"
          alt="citrus liberty"
          src="/img/liberty-logo.jpg"
        />
      </div>
    </div>
  )
}

export default ChooseBank
